export default "__VITE_ASSET__PKDwjzjG__"